import { render, staticRenderFns } from "./QueueingCalls.vue?vue&type=template&id=4d6606eb&scoped=true"
import script from "./QueueingCalls.vue?vue&type=script&lang=js"
export * from "./QueueingCalls.vue?vue&type=script&lang=js"
import style0 from "./QueueingCalls.vue?vue&type=style&index=0&id=4d6606eb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d6606eb",
  null
  
)

export default component.exports